import React from 'react'
import PostTextSection from '../slices/postTextSection'
import PostImage from '../slices/postImage'


const PostSlicesContainer = ({ slices }) => {
    return slices.map((slice, index) => {
        const res = (() => {
            switch (slice.slice_type) {
                case "text_section":
                    return <PostTextSection slice={slice} key={index} />
                case "image":
                    return <PostImage slice={slice} key={index} />
                default:
                    return
            }
        })()
        return res
    })
}

export default PostSlicesContainer